export const APP_ID = `iMonitor`;
export const APP_NAME = `COSBOTS - iMonitor`;
if (process.env.NODE_ENV === 'production') console.log = function () {};
